export enum BlockedReasonsEnum {
  "Blocked on RACF" = "Conta bloqueada por tentativas de senha incorreta.",
  "Blocked by high amount of consumption" = "Conta bloqueada por segurança devido ao consumo elevado.",
  "Blocked by inclusion" = "Conta bloqueada. Por favor, fale com nosso atendimento.",
  "Blocked by screen" = "Conta bloqueada por um administrador de acessos da sua empresa.",
  "Flag S - Blocked by the responsible agent" = "Conta bloqueada pelo agente responsável.",
  "Blocked by lack of document" = "Conta bloqueada. Por favor, fale com nosso atendimento.",
  "CNPJ is blocked by fraud" = "Conta bloqueada por segurança. Por favor, fale com nosso atendimento.",
  "CNPJ is blocked by lack of payment" = "Conta bloqueada por por pendência financeira. Regularize para desbloquear.",
  "Blocked by lack of payment" = "Conta bloqueada por por pendência financeira. Regularize para desbloquear.",
}

export enum BlockedReasonsENEnum {
  BLOCKED_BY_WRONG_PASS = "Blocked on RACF",
  BLOQUEADO_ALTO_CONSUMO = "Blocked by high amount of consumption",
  BLOQUEADO_INCLUSAO = "Blocked by inclusion",
  BLOCKED_MANUALLY = "Blocked by screen",
  BLOCKED_BY_RESPONSIBLE_AGENT = "Flag S - Blocked by the responsible agent",
  BLOQUEIO_FALTA_PAGAMENTO = "Blocked by lack of document",
  CNPJ_BLOQUEADO = "CNPJ is blocked by fraud",
  CNPJ_BLOQUEADO_FALTA_PAGAMENTO = "CNPJ is blocked by lack of payment",
  BLOQUEADO_FALTA_PAGAMENTO = "Blocked by lack of payment",
}
